import {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {UserInterface} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
// import {Languages} from './Languages'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {PATH_PROFILE, ROOTS_LOGOUT} from '../../../../app/routing/paths'

const HeaderUserMenu: FC = () => {
  const user: UserInterface = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface

  const {firstname, lastname, email, images} = user
  const image = images.length ? images[0].path : toAbsoluteUrl('/media/avatars/blank.png')

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-350px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={image} style={{objectFit: "cover"}} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {firstname} {lastname}
            </div>
            <span className='fw-bold text-muted fs-7'>
              {email}
            </span>
          </div>
        </div>
      </div>

      <div className="separator my-2"/>

      <div className='menu-item'>
        <Link to={PATH_PROFILE.edit} className="menu-link">
          <span className="menu-icon">
            <KTSVG path={'/media/icons/duotune/general/gen049.svg'} className="svg-icon-1" />
          </span>
          Informations Personelles
        </Link>
      </div>

      <div className='menu-item'>
        <Link to={PATH_PROFILE.products} className="menu-link">
          <span className="menu-icon">
            <KTSVG path={'/media/icons/duotune/abstract/abs014.svg'} className="svg-icon-1" />
          </span>
          Produits
        </Link>
      </div>

      <div className='menu-item'>
        <Link to={PATH_PROFILE.privacyPolicy} className="menu-link">
          <span className="menu-icon">
            <KTSVG path={'/media/icons/duotune/general/gen051.svg'} className="svg-icon-1" />
          </span>
          Politique de confidentialité
        </Link>
      </div>

      <div className="separator my-2" />

      {/* <Languages />{*/}

      <div className='menu-item'>
        <Link to={ROOTS_LOGOUT} className='menu-link'>
          <span className="menu-icon">
            <KTSVG path={'/media/icons/duotune/arrows/arr043.svg'} className="svg-icon-1" />
          </span>
          Déconnexion
        </Link>
      </div>

    </div>
  )
}

export {HeaderUserMenu}
